import React from 'react';

export const CarouselSectionWrapper = (props) => {
   return (
      <section id={'CarouselSection'} {...props}>
         {props.children}
      </section>
   );
};
